import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

export default function TextFieldDisabledComponent({ propsData, name }) {
  const { handleChange, values } = propsData;

  const sendDataToParent = (event) => {
    handleChange(event);
  };

  return (
    <Box
      component="form"
      sx={{
        "& .MuiTextField-root": { width: "100%" },
      }}
      noValidate
      autoComplete="off"
    >
      <TextField
        onChange={sendDataToParent}
        value={values[name]}
        name={name}
        disabled
      />
    </Box>
  );
}
